module.exports = __webpack_public_path__ + "static/media/icon-wrong.baf28a77.svg";